import { render, staticRenderFns } from "./PressTypeIndex.vue?vue&type=template&id=2e87b4f0&scoped=true&"
import script from "./PressTypeIndex.vue?vue&type=script&lang=js&"
export * from "./PressTypeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e87b4f0",
  null
  
)

export default component.exports